import moment from 'moment';

// Se a hora for 00:00, retorna apenas "DD/MM/YYYY"; caso contrário, "DD/MM/YYYY HH:mm"
export const formatDataHora = (value) => {
    if (!value) return '';
    const data = moment(value);
    if (!data.isValid()) return '';
    if (data.hours() === 0 && data.minutes() === 0) {
        return data.format('DD/MM/YYYY');
    }
    return data.format('DD/MM/YYYY HH:mm');
};
